import { fromJS } from 'immutable';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';

import { ITrainingModuleStore } from '../interfaces';
import { rootReducer } from '../reducers';
import { getUserData } from '../services/utilityServices';

export function configureStore(initialState: Object = {}): Store<ITrainingModuleStore> {
    const composeEnhancers = process.env && process.env.NODE_ENV === 'development' ?
        (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;
    const userData = getUserData();
    const login = userData ? fromJS(userData) : {};

    const configStore: Store<ITrainingModuleStore> = createStore(
        rootReducer,
        { ...rootReducer, login: login },
        composeEnhancers(
            applyMiddleware(...getMiddleWares())
        )
    );
    return configStore;
}

function getMiddleWares() {
    const middlewares = [
        thunk,
        promiseMiddleware()
    ];
    return middlewares;
}

export const store = configureStore();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/index.ts